export default class BlogCategories {
    
    constructor($axios) {
        this.$axios = $axios
        this.baseURL = process.env.BACKEND_URL
        // this.limit  = 3 , di backend set nya 
    }

    getAll() {
        return this.$axios.request({
			'url': `${this.baseURL}/v1/blog_category`,
			'method': 'GET',
			'headers': {
				'Content-Type': 'Application/json'
			}
		})
    }

    getAllLimit() {
        return this.$axios.request({
			'url': `${this.baseURL}/v1/blog_category_limit`,
			'method': 'GET',
			'headers': {
				'Content-Type': 'Application/json'
			}
		})
    }
}